<div class="flex flex-row">
	@if (leftLabel()) {
		<span class="mr-2 font-semibold">{{ leftLabel() }}</span>
	}
	<button
		type="button"
		role="switch"
		[attr.aria-checked]="checked()"
		[disabled]="disabled()"
		class="flex relative items-center justify-start cursor-pointer p-0 h-6 w-11 rounded-full transition-colors duration-200 border-outline border-1"
		[style.background]="
			checked() ? 'linear-gradient(135deg, var(--primary) 0%, #dc2626 100%)' : null
		"
		[class.bg-surface-container-highest]="!checked()"
		(click)="toggle(!checked())"
	>
		<span
			class="inline-block ml-1 h-4 w-4 transform rounded-full transition duration-200 text--on-primary"
			[class.translate-x-5]="checked()"
			[class.bg-on-primary]="checked()"
			[class.bg-outline]="!checked()"
		>
			@if (checked()) {
				<i class="bi bi-check relative bottom-1"></i>
			}
		</span>
	</button>
	@if (rightLabel()) {
		<span class="ml-2">{{ rightLabel() }}</span>
	}
</div>
